/* <vehicle-fit-notice> — "Passt / passt nicht"-Hinweis auf der Produktseite.
   Liest das im HEADER-Finder gewaehlte Fahrzeug (localStorage-Garage, kanonische
   fahrzeug.*-Werte) und vergleicht es mit den fahrzeug.*-Listen des Produkts
   (Enthaltensein). KEIN eigener Waehler — die Fahrzeugauswahl passiert im Header.
   Ohne gemerktes Fahrzeug: dezenter Prompt, der den Header-Finder oeffnet.
   Doku: docs/fahrzeugfilter-recherche.md */
(function () {
  'use strict';
  if (customElements.get('vehicle-fit-notice')) return;

  customElements.define('vehicle-fit-notice', class extends HTMLElement {
    connectedCallback() {
      this.key = this.getAttribute('data-storage-key') || 'cr-vehicle-v1';
      this.pMarke = this._arr('data-p-marke');
      this.pModell = this._arr('data-p-modell');
      this.pTyp = this._arr('data-p-typ');
      this.productType = this.getAttribute('data-product-type') || '';
      this.baseUrl = this.getAttribute('data-index-url') || '/collections/all';

      // Universal-/Nicht-Fahrzeug-Produkt (keine Marke) -> nie anzeigen.
      if (!this.pMarke.length) { this.hidden = true; return; }

      this.verdictEl = this.querySelector('[data-vfn-verdict]');
      this.titleEl = this.querySelector('[data-vfn-title]');
      this.discEl = this.querySelector('[data-vfn-discover]');
      this.changeEl = this.querySelector('[data-vfn-change]');
      this.promptEl = this.querySelector('[data-vfn-prompt]');

      if (this.changeEl) this.changeEl.addEventListener('click', this._openFinder.bind(this));
      if (this.promptEl) this.promptEl.addEventListener('click', this._openFinder.bind(this));

      this._onStorage = this._onStorage.bind(this);
      window.addEventListener('storage', this._onStorage);
      window.addEventListener('pageshow', this._onStorage);

      this.render();
    }

    disconnectedCallback() {
      window.removeEventListener('storage', this._onStorage);
      window.removeEventListener('pageshow', this._onStorage);
    }

    _onStorage(e) {
      if (e && e.type === 'storage' && e.key && e.key !== this.key) return;
      this.render();
    }

    /* ---------- helpers ---------- */
    _arr(attr) {
      try {
        var v = JSON.parse(this.getAttribute(attr) || '[]');
        return Array.isArray(v) ? v.map(function (x) { return String(x); }) : [];
      } catch (_) { return []; }
    }
    _norm(s) { return (s == null ? '' : String(s)).trim().toLowerCase(); }
    _has(list, val) {
      if (!val) return false;
      var n = this._norm(val);
      return list.some(function (x) { return this._norm(x) === n; }, this);
    }
    _veh() { try { return JSON.parse(localStorage.getItem(this.key)); } catch (_) { return null; } }

    _label(veh) {
      var parts = [veh.marke];
      // Modell weglassen, wenn der Typ es schon traegt (Kurzform "A4 B8"/"Astra G").
      if (veh.modell && (!veh.typ || this._norm(veh.typ).indexOf(this._norm(veh.modell)) === -1)) {
        parts.push(veh.modell);
      }
      if (veh.typ) parts.push(veh.typ);
      return parts.filter(Boolean).join(' ');
    }

    /* ---------- fitment verdict: 'fit' | 'maybe' | 'nofit' ---------- */
    _verdict(veh) {
      if (!this._has(this.pMarke, veh.marke)) return 'nofit';
      if (veh.typ && this.pTyp.length) return this._has(this.pTyp, veh.typ) ? 'fit' : 'nofit';
      if (veh.modell && this.pModell.length) return this._has(this.pModell, veh.modell) ? 'maybe' : 'nofit';
      return 'maybe';
    }

    _discoverUrl(veh) {
      // Ziel = die konkrete Fahrzeug-Collection aus der Garage (vom Header-Finder gebacken,
      // z. B. /collections/beleuchtung-bmw-x5-e70). Garantiert nicht leer.
      // KEIN product_type-Filter mehr: der fuehrte sonst z. B. bei Seitenblinker fuer ein
      // Fahrzeug ohne Seitenblinker auf eine leere Ergebnisliste.
      if (veh.url) return veh.url;
      // Fallback ohne Garage-URL: Fahrzeug-gefiltert (weiterhin ohne product_type).
      var p = [];
      if (veh.marke) p.push('filter.p.m.fahrzeug.marke=' + encodeURIComponent(veh.marke));
      if (veh.typ) p.push('filter.p.m.fahrzeug.fahrzeugtyp=' + encodeURIComponent(veh.typ));
      else if (veh.modell) p.push('filter.p.m.fahrzeug.modell=' + encodeURIComponent(veh.modell));
      return this.baseUrl + '?' + p.join('&');
    }

    render() {
      var veh = this._veh();
      this.classList.remove('vfn--fit', 'vfn--maybe', 'vfn--nofit', 'vfn--prompt');

      // Kein Fahrzeug gemerkt -> dezenter Prompt.
      if (!veh || !veh.marke) {
        this.classList.add('vfn--prompt');
        this.verdictEl.hidden = true;
        this.promptEl.hidden = false;
        this.hidden = false;
        return;
      }

      var level = this._verdict(veh);
      var label = this._label(veh);
      this.classList.add('vfn--' + level);

      if (level === 'fit') {
        this.titleEl.textContent = 'Passt an deinen ' + label;
        this.discEl.hidden = true;
      } else if (level === 'maybe') {
        this.titleEl.textContent = 'Könnte an deinen ' + label + ' passen – Typ prüfen';
        this.discEl.hidden = true;
      } else {
        this.titleEl.textContent = 'Passt nicht an deinen ' + label;
        this.discEl.textContent = 'Passendes für ' + label + ' entdecken';
        this.discEl.setAttribute('href', this._discoverUrl(veh));
        this.discEl.hidden = false;
      }

      this.promptEl.hidden = true;
      this.verdictEl.hidden = false;
      this.hidden = false;
    }

    // Oeffnet den Header-Fahrzeug-Finder (Auswahl passiert dort, nicht hier).
    _openFinder() {
      var finder = document.querySelector('[data-hvn-root][data-hvn-mode="live"]') ||
                   document.querySelector('[data-hvn-root]');
      if (!finder) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      finder.scrollIntoView({ block: 'center', behavior: 'smooth' });
      var edit = finder.querySelector('[data-hvn-edit]');
      var summary = finder.querySelector('[data-hvn-summary]');
      var trigger = (edit && !edit.hidden) ? edit : (summary && !summary.hidden ? summary : edit);
      if (trigger) { setTimeout(function () { trigger.click(); }, 320); }
    }
  });
})();
